import { LoginResponse } from "@app/core/user/domain/login.reponse";

/**
 * Mapper used to map the response from the login web service.
 */
export class LoginMapper {
  static deserialize(response: any): LoginResponse {
    return {
      token: response.token,
      completedProfile: response.completed_profile,
      accepted_policies: response.accepted_policies,
      email: response.email,
    };
  }
}
